// Random menu name pool for menu customization
// Each element is [line1, line2] format (max 10 chars per line)
// Note: Product names (coffee, ole, tea, cola, apple) are appended

export const RANDOM_MENU_NAMES: string[][] = [
  ['◯◯さん', 'お誕生日おめでとう'],
  ['◯◯さん　HAPPY', 'BIRTHDAY'],
  ['これからもずっと', '仲良くしてね'],
  ['◯◯と出会えた事が', '人生一の幸せ'],
  ['これからもずっと', '友だちでいてね'],
  ['生まれてきてくれて', 'ありがとう'],
  ['あなたをお祝いする', '祝杯の'],
  ['これからも', '応援してるよ'],
  ['今日は朝まで', '飲み明かそうよ'],
  ['未来が明るすぎて', 'サングラス必須'],
  ['世界一大好きだよ', ''],
  ['今日は私が', '奢るから飲んでよ'],
  ['あなたのために', '用意した'],
  ['お願いします', '結婚してください'],
  ['いつもそれ', '飲んでるよね'],
  ['今日のライブ', '絶対楽しむぞ'],
  ['私の推しが', '最高なんです'],
  // ['◯◯さん今日も', '生きていてくれてありがとう'],
  ['◯◯さん一生応援', 'させてください'],
  ['この前は本当に', 'ごめんなさい'],
  ['ダイエットは', '明日から'],
  ['今日はなんだか', 'いいこと起きそう'],
  ['寝ても寝ても', '眠いです'],
  ['強欲な私のための', ''],
  ['◯◯がいつも', '注文してる'],
  ['飲むと笑いが', '止まらなくなる'],
  ['飲むと人のことを', '褒めはじめてしまう'],
  ['この店に来たら', '外せない'],
  ['飲むといつもより', '少し素直になれる'],
  ['なんだかんだ', '一番美味しいのは'],
  ['田中が失恋した日に', '泣きながら飲んでた'],
  ['佐々木の', 'お気に入りの'],
  ['味にうるさい', 'あの吉田が認めた'],
  ['伊藤が部活終わりに', 'よく飲んでた'],
  ['楽しい時間だから', 'カロリーゼロ'],
  ['部長と残業中に', '一緒に飲んだ'],
  ['部長異動した後も', '元気でな'],
  ['今日くらいは', 'カロリー気にしないで'],
  ['ME ME', 'COFFEE特製'],
  ['店員さんが', '激推ししてきた'],
  ['ME ME', 'COFFEE大好き'],
  ['ME ME', 'COFFEEにきたよ'],
  ['ME ME', 'COFFEEたのしい'],
  ['MMC', '初来店記念！'],
  ['表参道で', '一番おいしい'],
  ['今日は表参道に', '遊びにきたよ'],
  ['今日は晴れて', 'よかった〜！'],
  ['メニュー名考えるの', '大変すぎだよ'],
  ['東京観光に', '遊びにきたよ'],
  ['これからも', 'よろしくよろしく'],
]

/**
 * Get a single random menu name (with duplicate avoidance)
 * @param excludeNames List of line1 values to exclude
 * @returns [line1, line2]
 */
export function getRandomMenuName(excludeNames: string[] = []): string[] {
  const availablePool = RANDOM_MENU_NAMES.filter(([line1]) => !excludeNames.includes(line1))
  const targetPool = availablePool.length > 0 ? availablePool : RANDOM_MENU_NAMES
  const randomIndex = Math.floor(Math.random() * targetPool.length)
  return targetPool[randomIndex]
}
